var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m26.17 56h-18.33a3.92 3.92 0 0 1 -3.84-4v-40a3.92 3.92 0 0 1 3.84-4h18.33a3.92 3.92 0 0 1 3.83 4v3.89a2 2 0 1 1 -4 0v-3.89h-18v40h18v-4.11a2 2 0 0 1 4 0v4.11a3.92 3.92 0 0 1 -3.83 4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m56.13 56h-18.33a3.92 3.92 0 0 1 -3.8-4v-4a2 2 0 1 1 4 0v4h18v-40h-18v3.94a2 2 0 1 1 -4 0v-3.94a3.92 3.92 0 0 1 3.8-4h18.33a3.92 3.92 0 0 1 3.87 4v40a3.92 3.92 0 0 1 -3.87 4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m29.35 30.58-.05-.06-5.66-5.66a2 2 0 0 0 -2.83 2.83l2.33 2.31h-9.14a2 2 0 0 0 0 4h9.19l-2.3 2.3a2 2 0 0 0 2.83 2.83l5.66-5.66a2.88 2.88 0 0 0 .27-.34 2 2 0 0 0 -.26-2.56z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m50 30h-9.14l2.32-2.33a2 2 0 0 0 -2.83-2.83l-5.65 5.69-.06.07a2 2 0 0 0 -.64 1.4 2.05 2.05 0 0 0 .34 1.12 2.24 2.24 0 0 0 .27.34l5.66 5.66a2 2 0 0 0 2.83-2.83l-2.25-2.29h9.15a2 2 0 0 0 0-4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegular);
export default __webpack_public_path__ + "static/media/Regular.7958aba2.svg";
export { ForwardRef as ReactComponent };